import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";

interface IKeepMountedProps {
  as?: any;
  children?: any;
  isShown: boolean;
}

const DefaultHide = ({ isShown, children }) => (
  <Box sx={isShown ? {} : { display: "none" }}>{children}</Box>
);

/**
 * This is a simple component which keeps its children mounted in the DOM
 * after the first time they are shown.
 *
 * This is useful for e.g. returning to tabs without losing internal state by
 * retriggering slow initial loads (and where for whatever reason a store is
 * not a good solution), or where the element can be hidden but governs other
 * elements (such as persistent alerts) which are not.
 *
 * <KeepMounted isShown="item.id == idShown">
 *   <SomeComponent />
 * </KeepMounted>
 */
export function KeepMounted(props: IKeepMountedProps) {
  const [hasBeenShown, setHasBeenShown] = useState<boolean>(false);

  useEffect(() => {
    if (props.isShown) {
      setHasBeenShown(true);
    }
  }, [props.isShown]);

  const Hide = props.as ?? DefaultHide;

  return hasBeenShown ? (
    <Hide isShown={props.isShown}>{props.children}</Hide>
  ) : null;
}
